import React, { useState, useEffect, useRef } from "react"
import GalleryProduct from "../gallery-product/gallery-product"
import HeartScore from "../../atoms/heart-score/heart-score"
import ModalVideo from "../modal-video/modal-video"
import "./info-details-product.scss"
import { createListProductPayload } from "../../../shared/utils/payloadDatalayer"
import { pushGtagEvent, pushDataLayerEvent} from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"

const InfoDetailsProduct = ({
  isActive,
  setModalActive,
  params,
  isSecret,
  averageScore,
  numberOfRatings,
  mobile,
  title
}) => {
  const [activeColor, setActiveColor] = useState("negro")
  const [activeSize, setActiveSize] = useState("talla p")
  const [activeType, setActiveType] = useState("corta")


  const [images, setImages] = useState(params.imagenesRotador || [])
  const refGallery = useRef()
  const handleRedirectVideo = () => {
    if (mobile) {
      window.location.href = params.video
    } else {
      setModalActive(
        <ModalVideo setModalActive={setModalActive} url={params.video} />
      )
    }
  }
  const isCup = params.codigoDeProducto.includes("CUP")
  const isToallaReu = params.codigoDeProducto.includes("TREU")
  const isIntima = params.codigoDeProducto.includes("SECRET")


  const changeLabelFlujos = (flujo) =>{
    let nameFlujos = flujo
    if( flujo === 'Liviano'){
      nameFlujos='Regular'
    }else if( flujo === 'Normal'){
      nameFlujos='Abundante'
    }else {
      nameFlujos='Súper Abundante'
    }
    return nameFlujos
  }

  const userInfoEncrypt = encryptUserInfo()
  const pushDatalayer = url => {
    const items = createListProductPayload([params])
    const retailNameFromUrl = url.split("/")[2] || ''
    const retailWithOutWWW = retailNameFromUrl.replace("www.", "")
    const retailName = retailWithOutWWW.split(".")?.[0] || ''

    pushGtagEvent({
      event: "add_to_cart",
      params: {
        value: 0,
        option: retailName,
        points: 0,
        currency: "COP",
        redemption: "No",
        items,
        user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
        log_status: userInfoEncrypt.log_status,
      },
    })
    pushDataLayerEvent({
      event: "buy_now_go_to_retailer",
      retailer: retailName,
      single_item_id: items[0]?.item_id || '',
      single_item_name: items[0]?.item_name || ''
    })
  }
  const datalayerRetailer = (url) => {
    const retailNameFromUrl = url.split("/")[2] || ''
    const retailWithOutWWW = retailNameFromUrl.replace("www.", "")
    const retailName = retailWithOutWWW.split(".")?.[0] || ''
    pushDataLayerEvent({
      event: 'gaEvent',
      eventTrigger: 'BIN',
      eventCategory: 'Buy Now - Retailer Click – Page URL',
      eventAction: title,
      eventLabel: window.location.href,
      eventValue: undefined,
    })
    pushDataLayerEvent({
      event: 'gaEvent',
      eventTrigger: 'BIN',
      eventCategory: 'Buy Now - Retailer click – Retailer Domain',
      eventAction: title,
      eventLabel: retailName,
      eventValue: undefined,
    })
  }
  useEffect(() => {
    if (isSecret && !isCup && !isToallaReu) {
      const colorFilter = params.imagenesRotador.filter(item => {
        return item.title.includes(activeColor)
      })
      if (colorFilter.length > 0) {
        setImages(colorFilter)
      }
    }
  }, [activeColor])

  useEffect(() => {
    if (isCup) {
      const sizeFilter = params.imagenesRotador.filter(item => {
        return item.title.includes(activeSize)
      })
      if (sizeFilter.length > 0) {
        setImages(sizeFilter)
      }
    }
  }, [activeSize])

  useEffect(() => {
    if (isToallaReu) {
      const typeFilter = params.imagenesRotador.filter(item => {
        return item.title.includes(activeType)
      })
      if (typeFilter.length > 0) {
        setImages(typeFilter)
      }
    }
  }, [activeType])
  return (
    <div className={`f-details-product ${!isActive ? "f-inactive-tab" : ""}`}>
      <GalleryProduct
        ref={refGallery}
        images={[
          ...(!isSecret ? [params.imagenDelProducto] : []),
          ...images,
          ...(params.tieneVideo
            ? [{ ...params.previsualizacionDeVideo, isVideo: true }]
            : []),
        ]}
        onClickVideo={handleRedirectVideo}
      />

      <div className="f-text-details-container">
        <div className="f-section-details">
          <label className="f-qualification-label">Calificación</label>
          <div className="f-likes-container">
            <HeartScore score={averageScore || 0} />
            <div className="f-hearts-label">
              {numberOfRatings
                ? numberOfRatings + " calificaciones"
                : "0 calificaciones"}
            </div>
          </div>

          {(params.flujo && title.includes('Protectores') !== true && !title.includes('V-Cup')) && !isIntima &&
            (
              <div className="f-flujo">
                <span
                  className={`f-icon-flujo f-icon-flujo--${params.flujo[0].toLowerCase()}`}
                />
                {params.flujo.includes('Todos')
                  ? "Todo tipo de flujo"
                  : (title === 'Toallas Nosotras Maternidad') ? `Flujo ${changeLabelFlujos(params.flujo[0])} - Posparto` : `Flujo ${changeLabelFlujos(params.flujo[0])}`}
              </div>
            )}

          <div className="f-details-container">
            {params.descripcionCompleta &&
              params.descripcionCompleta.descripcionCompleta
                .split("\n")
                .map((fragm, index) => {
                  if(fragm[0]==='_'){
                    return(<><b style={{'font-size': '14px'}}>{fragm.substring(2,fragm.length-2)}</b><br /><br /></>)
                  }else{
                    return(<p key={index} className="f-p">{fragm}</p>)
                  }
                })
              }
                
          </div>
          {isToallaReu && (
            <p className="f-description">**Según el tipo de flujo</p>
          )}
          {isToallaReu && (
            <div className="f-container-colors-product ">
              
              <div className="f-title-colors">Tipo de flujo:</div>
              <div
                className={`f-type-product corta ${activeType === "corta" ? "active" : ""
                  }`}
                onClick={() => setActiveType("corta")}
              >
                <b className="f-type">Leve</b>
              </div>

              {params.imagenesRotador &&
                params.imagenesRotador.filter(item => {
                  return item.title.includes("regular")
                }).length > 0 && (
                  <div
                    className={`f-type-product regular ${activeType === "regular" ? "active" : ""
                      }`}
                    onClick={() => setActiveType("regular")}
                  >
                    <b className="f-type">Regular</b>
                  </div>
                )}
            </div>
          )}
          {isCup && (
            <div className="f-container-colors-product ">
              <div className="f-title-colors">Talla:</div>
              <div
                className={`f-size-product tallap ${activeSize === "talla p" ? "active" : ""
                  }`}
                onClick={() => setActiveSize("talla p")}
              >
                <b className="f-size">P</b>
              </div>

              {params.imagenesRotador &&
                params.imagenesRotador.filter(item => {
                  return item.title.includes("talla g")
                }).length > 0 && (
                  <div
                    className={`f-size-product tallag ${activeSize === "talla g" ? "active" : ""
                      }`}
                    onClick={() => setActiveSize("talla g")}
                  >
                    <b className="f-size">G</b>
                  </div>
                )}
            </div>
          )}
          {isSecret && !isCup && !isToallaReu&& (
            <div className="f-container-colors-product ">
              <div className="f-title-colors">Color:</div>
              <div
                className={`f-colors-product black ${activeColor === "negro" ? "active" : ""
                  }`}
                onClick={() => setActiveColor("negro")}
              >
                <div className="f-color"></div>
              </div>

              {!["es-BO", "es-CL"].includes(process.env.LOCALE)
                && params.imagenesRotador &&
                params.imagenesRotador.filter(item => {
                  return item.title.includes("rojo")
                }).length > 0 && (
                  <div
                    className={`f-colors-product red ${activeColor === "rojo" ? "active" : ""
                      }`}
                    onClick={() => setActiveColor("rojo")}
                  >
                    <div className="f-color"></div>
                  </div>
                )}

              {process.env.LOCALE === "es-CO" &&
                params.imagenesRotador &&
                params.imagenesRotador.filter(item => {
                  return item.title.includes("fucsia")
                }).length > 0 && (
                  <div
                    className={`f-colors-product fucsia ${activeColor === "fucsia" ? "active" : ""
                      }`}
                    onClick={() => setActiveColor("fucsia")}
                  >
                    <div className="f-color"></div>
                  </div>
                )}

              {process.env.LOCALE === "es-CO" &&
                params.imagenesRotador &&
                params.imagenesRotador.filter(item => {
                  return item.title.includes("azul")
                }).length > 0 && (
                  <div
                    className={`f-colors-product blue ${activeColor === "azul" ? "active" : ""
                      }`}
                    onClick={() => setActiveColor("azul")}
                  >
                    <div className="f-color"></div>
                  </div>
                )}
            </div>
          )}
        </div>

        {params.tiendas && process.env.LOCALE !== "es-UY" && (isCup && process.env.LOCALE !== "es-CL") && (
          <>
            <label className="f-shops-label">
              {process.env.LOCALE === "es-CL"
                ? "Venta exclusiva en:"
                : "Cómpralo Online"}
            </label>
            <div className="f-shops-container">
              {params.tiendas &&
                params.tiendas.map(({ imagen, redireccion }) => (
                  <a
                    className="f-shop"
                    href={redireccion}
                    target="_blank"
                    onClick={() =>  {datalayerRetailer(redireccion)
                                    pushDatalayer(redireccion)}}
                  >
                    <img src={imagen[0].file.url} className="f-shop__img" />
                  </a>
                ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default InfoDetailsProduct
